import { useState, useEffect } from 'react';
import { getCachedUser } from '@/utils/userCache';

export function useCurrentUser() {
  const [user, setUser] = useState(() => getCachedUser());

  useEffect(() => {
    const handleUpdate = () => {
      setUser(getCachedUser());
    };

    window.addEventListener('user-updated', handleUpdate);
    window.addEventListener('storage', handleUpdate);

    return () => {
      window.removeEventListener('user-updated', handleUpdate);
      window.removeEventListener('storage', handleUpdate);
    };
  }, []);

  return user;
}
